<template>
  <gmap-map
      ref="laCarte"
      :center="center"
      :zoom="zoom"
      :map-type-id="typeMap"
      :options="options">
      <gmap-marker
          v-for="(m, index) in markers"
          :key="index"
          :position="m.position"
          :draggable="m.draggable"
          :clickable="m.clickable"
          :icon="m.icon"
          @click="$emit('markClicked', m)"/>
  </gmap-map>
</template>

<script>
import { CENTER_DEFAULT, ZOOM_DEFAULT, STYLE_MAPS_POI_HIDDEN } from '@/configuration/general/carteConf';

export default {
  name: 'carteComponent',
  props: {
    markers: {
      type: Array,
      required: true,
      validator: (values) => {
        return values.every(v => {
          return v.position && v.icon;
        });
      },
    },
    zoom: {
      type: Number,
      default: ZOOM_DEFAULT,
    },
    center: {
      type: Object,
      default: () => {
        return CENTER_DEFAULT;
      },
    },
    options: {
      type: Object,
      default: () => {
        return {
          zoomControl: true,
          mapTypeControl: true,
          scaleControl: true,
          streetViewControl: true,
          rotateControl: false,
          fullscreenControl: true,
          disableDefaultUi: false,
          mapTypeControlOptions: {
            mapTypeIds: ['roadmap', 'satellite', 'no_POI_map'],
          },
        };
      },
    },
    typeMap: {
      type: String,
      default: 'roadmap',
    },
    isStreetView: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    updateBounds(map) {
      const bounds = new google.maps.LatLngBounds();
      this.markers.forEach(mark => {
        bounds.extend(mark.position);
      });
      map.fitBounds(bounds);
    },
  },
  watch: {
    async markers() {
      const map = await this.$refs.laCarte.$mapPromise;
      if (this.markers.length > 0) {
        this.updateBounds(map);
      }
    },
  },
  async mounted() {
    const map = await this.$refs.laCarte.$mapPromise;
    if (this.markers.length > 0) {
      this.updateBounds(map);
    }
    const styleMap = new google.maps.StyledMapType(
      STYLE_MAPS_POI_HIDDEN,
      { name: 'Cacher POI' },
    );
    map.mapTypes.set('no_POI_map', styleMap);
  },
};
</script>

<style>

</style>
